import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import galaxyLogo from '../../Assets/Images/LogoImages/galaxy-specialised-waterproofing.webp';
import cormixLogo from '../../Assets/Images/LogoImages/cormix-galaxy-waterproofing-dubai-uae.webp';
import WaterproofingIcon from '../../Assets/Icons/cormix-h2o-stop-mixed-with-concrete.webp';
import LeakageIcon from '../../Assets/Icons/leakage-repair-with-crystalline-waterproofing-solutions.webp';
import { PRODUCT_LINKS } from '../../constants';
import '../../styles/Navbar.css';

const Navbar = () => {
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);

  const closeMobileMenu = () => setIsMobileMenuVisible(false);

  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      <div className="navbar-container">
        <div className="logo-container">
          <NavLink to="/" aria-label="Galaxy Specialised Waterproofing — Home">
            <img src={galaxyLogo} alt="Galaxy Specialised Waterproofing logo" className="logo" />
          </NavLink>
          <a href="https://www.cormix.com/" target="_blank" rel="noopener noreferrer" aria-label="Visit Cormix International website">
            <img src={cormixLogo} alt="Cormix International — authorised distributor Galaxy UAE" className="logo cormix-logo" />
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="hamburger"
          onClick={() => setIsMobileMenuVisible((v) => !v)}
          aria-expanded={isMobileMenuVisible}
          aria-controls="mobile-menu"
          aria-label={isMobileMenuVisible ? 'Close menu' : 'Open menu'}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        {/* Mobile Menu */}
        {isMobileMenuVisible && (
          <div id="mobile-menu" className="mobile-menu">
            <NavLink to="/" onClick={closeMobileMenu}>Home</NavLink>
            <NavLink to="/about" onClick={closeMobileMenu}>About</NavLink>
            <NavLink to="/services" onClick={closeMobileMenu}>Services</NavLink>
            <NavLink to="/products" onClick={closeMobileMenu}>Products</NavLink>
            <NavLink to="/contact" onClick={closeMobileMenu}>Contact Us</NavLink>
          </div>
        )}

        {/* Desktop Links */}
        <div className="nav-links">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/about">About</NavLink>

          {/* Services Dropdown */}
          <div
            className="services-dropdown"
            onMouseEnter={() => setIsServicesOpen(true)}
            onMouseLeave={() => setIsServicesOpen(false)}
          >
            <NavLink to="/services" aria-haspopup="true" aria-expanded={isServicesOpen}>
              Services <span className="arrow" aria-hidden="true">▼</span>
            </NavLink>
            <div className="dropdown-menu" role="menu">
              <NavLink to="/services/foundation-waterproofing" role="menuitem">
                <img src={WaterproofingIcon} alt="" className="nav-icon" aria-hidden="true" /> Concrete Substructure Waterproofing
              </NavLink>
              <NavLink to="/services/leakage-repair" role="menuitem">
                <img src={LeakageIcon} alt="" className="nav-icon" aria-hidden="true" /> Concrete Leakage Repair
              </NavLink>
            </div>
          </div>

          {/* Products Dropdown */}
          <div
            className="products-dropdown"
            onMouseEnter={() => setIsProductsOpen(true)}
            onMouseLeave={() => setIsProductsOpen(false)}
          >
            <NavLink to="/products" aria-haspopup="true" aria-expanded={isProductsOpen}>
              Products <span className="arrow" aria-hidden="true">▼</span>
            </NavLink>
            <div className="dropdown-menu" role="menu">
              {Object.entries(PRODUCT_LINKS).map(([name, url]) => (
                <a key={name} href={url} target="_blank" rel="noopener noreferrer" role="menuitem">
                  {name}
                </a>
              ))}
            </div>
          </div>

          <NavLink to="/contact">Contact Us</NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
